import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

@Injectable({ providedIn: 'root' })
export class MetaTagsService {
  constructor(private meta: Meta, private titleService: Title) {}

  setMetaTags(title: string, url: string, description: string, image: string): void {
    const safeTitle = title?.trim() || 'Udaan Hotels & Resorts';
    const safeDesc =
      description?.trim() ||
      'Explore hotels across India with Udaan Hotels & Resorts. View stays, amenities, photos and availability.';

    this.titleService.setTitle(safeTitle);

    this.meta.updateTag({ name: 'description', content: safeDesc });

    this.meta.updateTag({ property: 'og:title', content: safeTitle });
    if (url) this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:description', content: safeDesc });

    if (image?.trim()) {
      this.meta.updateTag({ property: 'og:image', content: image });
    } else {
      // optional: remove og:image if empty to avoid wrong caching
      this.meta.removeTag(`property='og:image'`);
    }
  }

  setDefault(url: string = ''): void {
    this.setMetaTags(
      'Udaan Hotels & Resorts',
      url,
      'Explore hotels across India with Udaan Hotels & Resorts. View stays, amenities, photos and availability.',
      ''
    );
  }
}
